import React, { useState, useEffect } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { iniciativasAPI } from '../services/api';
import SupervisionModal from '../components/SupervisionModal';
import EnlacePropuestaModal from '../components/EnlacePropuestaModal';
import FechaEntregaRealModal from '../components/FechaEntregaRealModal';
import MotivoRechazoModal from '../components/MotivoRechazoModal';
import AprobadaModal from '../components/AprobadaModal';
import './KanbanComercial.css';

// Componente para la tarjeta de iniciativa
const IniciativaCard = ({ iniciativa, onDragStart, isDragging }) => {
  const [isHovered, setIsHovered] = React.useState(false);
  
  const handleDragStart = (e) => {
    e.dataTransfer.setData('text/plain', iniciativa.id);
    e.dataTransfer.setData('application/json', JSON.stringify(iniciativa));
    onDragStart(iniciativa);
  };

  const handleDragEnd = (e) => {
    onDragStart(null);
  };

  const formatCurrency = (amount) => {
    if (!amount) return 'No definido';
    return new Intl.NumberFormat('es-ES', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: true
    }).format(amount);
  };

  return (
    <div
      className={`iniciativa-card ${isDragging ? 'dragging' : ''}`}
      draggable
      onDragStart={handleDragStart}
      onDragEnd={handleDragEnd}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-estado={iniciativa.estado}
      style={{
        backgroundColor: isHovered && !isDragging ? '#f8f9fa' : '#fff',
        border: isDragging ? '2px solid #495057' : (isHovered ? '1px solid #adb5bd' : '1px solid #d1d7dc'),
        borderRadius: '6px',
        padding: '8px',
        margin: '4px 0',
        fontSize: '12px',
        boxShadow: isDragging 
          ? '0 8px 16px rgba(0,0,0,0.25), 0 0 0 3px rgba(0,0,0,0.1)' 
          : (isHovered ? '0 3px 8px rgba(0,0,0,0.15)' : '0 1px 2px rgba(0,0,0,0.1)'),
        cursor: isDragging ? 'grabbing' : 'grab',
        transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
        minHeight: '100px',
        maxHeight: '120px',
        overflow: 'hidden',
        opacity: isDragging ? 0.7 : 1,
        transform: isDragging 
          ? 'rotate(-2deg) scale(1.05)' 
          : (isHovered ? 'translateY(-2px) scale(1.01)' : 'translateY(0) scale(1)')
      }}
    >
      <div style={{ marginBottom: '6px', borderBottom: '1px solid #e1e4e8', paddingBottom: '4px' }}>
        <Link 
          to={`/projects/${iniciativa.id}?from=desarrollo_negocio`}
          onClick={(e) => e.stopPropagation()}
          style={{ textDecoration: 'none' }}
        >
          <h6 style={{ 
            fontSize: '11px', 
            fontWeight: '600', 
            margin: '0', 
            lineHeight: '1.2',
            color: '#444',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2,
            WebkitBoxOrient: 'vertical',
            cursor: 'pointer',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.target.style.color = '#000000'}
          onMouseLeave={(e) => e.target.style.color = '#444'}
          >
            {iniciativa.nombre_de_la_oportunidad}
          </h6>
        </Link>
      </div>
      
      <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '9px', color: '#6a737d', fontWeight: '500' }}>Negocio:</span>
          <span style={{ 
            fontSize: '9px', 
            color: iniciativa.negocio_estructura_nombre ? '#24292e' : '#dc3545',
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '120px',
            whiteSpace: 'nowrap'
          }}>{
            iniciativa.negocio_estructura_nombre || 
            'No definido'
          }</span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '9px', color: '#6a737d', fontWeight: '500' }}>Responsable:</span>
          <span style={{ 
            fontSize: '9px', 
            color: (iniciativa.responsable_comercial_nombre || iniciativa.responsable_comercial || iniciativa.assigned_to || (iniciativa.personas && iniciativa.personas.find(p => p.rol === 'responsable_comercial')?.persona?.nombre)) ? '#24292e' : '#dc3545',
            textAlign: 'right',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            maxWidth: '120px',
            whiteSpace: 'nowrap'
          }}>{
            iniciativa.responsable_comercial_nombre ||
            iniciativa.responsable_comercial ||
            iniciativa.assigned_to ||
            (iniciativa.personas && iniciativa.personas.find(p => p.rol === 'responsable_comercial')?.persona?.nombre) ||
            'No definido'
          }</span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '9px', color: '#6a737d', fontWeight: '500' }}>Importe de venta:</span>
          <span style={{ 
            fontSize: '9px', 
            color: iniciativa.importe_total_cliente ? '#24292e' : '#dc3545',
            fontWeight: '600',
            textAlign: 'right'
          }}>
            {iniciativa.importe_total_cliente ? formatCurrency(iniciativa.importe_total_cliente) : 'No definido'}
          </span>
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span style={{ fontSize: '9px', color: '#6a737d', fontWeight: '500' }}>Entrega planificada:</span>
          <span style={{ 
            fontSize: '9px', 
            color: iniciativa.fecha_de_entrega_propuesta_prevista ? '#24292e' : '#dc3545',
            textAlign: 'right'
          }}>
            {iniciativa.fecha_de_entrega_propuesta_prevista ? 
              new Date(iniciativa.fecha_de_entrega_propuesta_prevista).toLocaleDateString('es-ES', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 
              'No definido'
            }
          </span>
        </div>
      </div>
    </div>
  );
};

// Componente para la columna del Kanban
const KanbanColumn = ({ estado, titulo, iniciativas, onDrop, onDragOver, draggedItem, onDragStart, isFiltered = false }) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const isEmpty = iniciativas.length === 0;

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragOver(false);
    const iniciativaData = JSON.parse(e.dataTransfer.getData('application/json'));
    onDrop(iniciativaData, estado);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragOver(true);
    onDragOver(e);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    // Solo desactivar isDragOver si realmente salimos del elemento y no solo pasamos a un hijo
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX;
    const y = e.clientY;
    
    if (x < rect.left || x >= rect.right || y < rect.top || y >= rect.bottom) {
      setIsDragOver(false);
    }
  };

  const getColumnColor = (estado) => {
    const colors = {
      'oportunidad_identificada': '#f8f9fa',
      'en_preparacion_propuesta': '#fff3e0',
      'supervision': '#e8f5e8',
      'entregada': '#fff8e1',
      'rechazada': '#ffebee',
      'stand_by': '#f3e5f5',
      'aprobada': '#e8f5e8',
    };
    return colors[estado] || '#f8f9fa';
  };

  return (
    <div 
      className={`kanban-column ${isDragOver ? 'drag-over' : ''} ${isFiltered ? 'filtered-column' : ''} ${isEmpty ? 'empty-column' : ''}`}
      style={{ 
        backgroundColor: isEmpty ? '#fafbfc' : getColumnColor(estado),
        border: isDragOver ? '3px dashed #5a6268' : (isFiltered ? '2px solid #1976d2' : '1px solid #d1d7dc'),
        borderRadius: '6px',
        margin: '0 4px',
        minWidth: isEmpty ? (isDragOver ? '180px' : '60px') : (isDragOver ? '240px' : '200px'),
        maxWidth: isEmpty ? (isDragOver ? '240px' : '60px') : (isDragOver ? '280px' : '220px'),
        width: isEmpty ? (isDragOver ? '200px' : '60px') : (isDragOver ? '250px' : '200px'),
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: isDragOver 
          ? '0 8px 24px rgba(0,0,0,0.3), 0 0 0 4px rgba(0,0,0,0.08)' 
          : (isFiltered ? '0 2px 8px rgba(25,118,210,0.2)' : '0 1px 3px rgba(0,0,0,0.1)'),
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: isEmpty && !isDragOver ? 0.6 : 1,
        transform: isDragOver ? 'scale(1.02)' : 'scale(1)',
        zIndex: isDragOver ? 10 : 1
      }}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      title={isEmpty ? `${titulo} - Vacía` : titulo}
    >
      <div style={{
        padding: isEmpty && !isDragOver ? '6px 4px' : '8px 10px',
        borderBottom: '1px solid #e1e4e8',
        backgroundColor: isDragOver ? '#495057' : (isFiltered ? '#e3f2fd' : '#f6f8fa'),
        borderRadius: '6px 6px 0 0',
        flexShrink: 0,
        writingMode: isEmpty && !isDragOver ? 'vertical-rl' : 'horizontal-tb',
        textOrientation: isEmpty && !isDragOver ? 'mixed' : 'unset',
        transition: 'all 0.3s ease'
      }}>
        {isEmpty && !isDragOver ? (
          // Vista minimizada para columnas vacías
          <div style={{ 
            display: 'flex', 
            flexDirection: 'column', 
            alignItems: 'center',
            gap: '4px',
            height: '100px'
          }}>
            <span style={{
              fontSize: '9px',
              fontWeight: '600',
              color: '#6a737d',
              textAlign: 'center',
              lineHeight: '1.1',
              writingMode: 'vertical-rl',
              textOrientation: 'mixed',
              whiteSpace: 'nowrap'
            }}>
              {titulo}
            </span>
            <span style={{
              backgroundColor: '#6a737d',
              color: 'white',
              fontSize: '8px',
              fontWeight: '600',
              padding: '2px 4px',
              borderRadius: '8px',
              minWidth: '14px',
              textAlign: 'center'
            }}>
              0
            </span>
          </div>
        ) : (
          // Vista normal para columnas con contenido
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h5 style={{ 
              fontSize: isDragOver ? '14px' : '12px',
              fontWeight: '600',
              margin: '0',
              color: isDragOver ? '#ffffff' : (isFiltered ? '#1976d2' : '#24292e'),
              lineHeight: '1.2',
              transition: 'all 0.3s ease'
            }}>
              {titulo}
              {isFiltered && !isDragOver && <span style={{ marginLeft: '4px', fontSize: '10px' }}>📌</span>}
              {isDragOver && <span style={{ marginLeft: '8px', fontSize: '14px' }}>⬇️</span>}
            </h5>
            <span style={{
              backgroundColor: isDragOver ? '#ffffff' : (isFiltered ? '#1976d2' : '#6a737d'),
              color: isDragOver ? '#495057' : 'white',
              fontSize: '9px',
              fontWeight: '600',
              padding: '2px 6px',
              borderRadius: '10px',
              minWidth: '18px',
              textAlign: 'center',
              transition: 'all 0.3s ease'
            }}>
              {iniciativas.length}
            </span>
          </div>
        )}
      </div>
      
      {(!isEmpty || isDragOver) && (
        <div style={{
          flex: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          padding: '6px',
          scrollbarWidth: 'thin',
          scrollbarColor: '#d1d7dc transparent',
          backgroundColor: isDragOver ? 'rgba(0, 0, 0, 0.03)' : 'transparent',
          border: isDragOver ? '2px dashed rgba(0, 0, 0, 0.2)' : 'none',
          borderRadius: isDragOver ? '4px' : '0',
          margin: isDragOver ? '4px' : '0',
          transition: 'all 0.3s ease',
          minHeight: isDragOver && isEmpty ? '100px' : 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: isDragOver && isEmpty ? 'center' : 'stretch',
          justifyContent: isDragOver && isEmpty ? 'center' : 'flex-start'
        }}>
          {isDragOver && isEmpty && (
            <div style={{
              textAlign: 'center',
              color: '#495057',
              fontSize: '12px',
              fontWeight: '500',
              padding: '20px'
            }}>
              Soltar aquí
            </div>
          )}
          {iniciativas.map(iniciativa => (
            <IniciativaCard
              key={iniciativa.id}
              iniciativa={iniciativa}
              onDragStart={onDragStart}
              isDragging={draggedItem && draggedItem.id === iniciativa.id}
            />
          ))}
        </div>
      )}
    </div>
  );
};

const KanbanComercial = ({ 
  embedded = false,
  añosFiltro = [],
  searchTerm = '',
  estadosFiltro = [],
  negociosFiltro = [],
  lineasNegocioFiltro = [],
  subnegociosFiltro = [],
  tecnologiasFiltro = [],
  probabilidadesFiltro = [],
  contactosFiltro = [],
  iniciativas = [],
  loading = false,
  onRefresh = null
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  
  // Estados para el modal de supervisión
  const [supervisionModalOpen, setSupervisionModalOpen] = useState(false);
  const [pendingStateChange, setPendingStateChange] = useState(null);
  const [supervisionStatus, setSupervisionStatus] = useState(null);
  const [supervisionLoading, setSupervisionLoading] = useState(false);
  
  // Estados para el modal de enlace propuesta
  const [enlaceModalOpen, setEnlaceModalOpen] = useState(false);
  const [enlaceActual, setEnlaceActual] = useState('');
  const [enlaceLoading, setEnlaceLoading] = useState(false);

  // Modal para fecha de entrega real
  const [fechaEntregaRealModalOpen, setFechaEntregaRealModalOpen] = useState(false);
  const [fechaEntregaReal, setFechaEntregaReal] = useState('');
  const [pendingFechaEntregaReal, setPendingFechaEntregaReal] = useState(null);

  // Modal para motivo de rechazo
  const [motivoRechazoModalOpen, setMotivoRechazoModalOpen] = useState(false);
  const [pendingRechazo, setPendingRechazo] = useState(null);

  // Modal para campos requeridos al aprobar
  const [aprobadaModalOpen, setAprobadaModalOpen] = useState(false);
  const [pendingAprobada, setPendingAprobada] = useState(null);
  const [aprobadaLoading, setAprobadaLoading] = useState(false);

  // Estados comerciales del Kanban
  const estadosComerciales = [
    { key: 'oportunidad_identificada', label: 'Identificada' },
    { key: 'en_preparacion_propuesta', label: 'En preparación' },
    { key: 'supervision', label: 'Supervisión' },
    { key: 'entregada', label: 'Entregada' },
    { key: 'stand_by', label: 'Stand-By' },
    { key: 'rechazada', label: 'Rechazada' },
    { key: 'aprobada', label: 'Aprobada' },
  ];

  const handleDrop = async (iniciativa, nuevoEstado) => {
    if (iniciativa.estado === nuevoEstado) {
      return;
    }

    // Si se está intentando mover a 'rechazada', verificar motivo_tipificado
    if (nuevoEstado === 'rechazada' && !iniciativa.motivo_tipificado) {
      setPendingRechazo({ iniciativa, nuevoEstado });
      setMotivoRechazoModalOpen(true);
      return;
    }

    // Verificar si requiere enlace al documento (supervision, entregada o aprobada)
    if (nuevoEstado === 'supervision' || nuevoEstado === 'entregada' || nuevoEstado === 'aprobada') {
      try {
        const enlaceResponse = await iniciativasAPI.checkEnlacePropuesta(iniciativa.id);
        
        if (!enlaceResponse.data.tiene_enlace) {
          // Mostrar modal de enlace
          setPendingStateChange({ iniciativa, nuevoEstado });
          setEnlaceActual(enlaceResponse.data.enlace_al_documento_ppt_sharepoint || '');
          setEnlaceModalOpen(true);
          return;
        }
      } catch (err) {
        console.error('Error al verificar enlace:', err);
        setError('Error al verificar el enlace de la iniciativa');
        setTimeout(() => setError(null), 5000);
        return;
      }
    }

    // Si se está intentando mover a "entregada", o a "aprobada" sin fecha entrega real, mostrar modal fecha
    if (nuevoEstado === 'entregada' || (nuevoEstado === 'aprobada' && !iniciativa.fecha_de_entrega_propuesta_real)) {
      // Proponer fecha de hoy por defecto
      const hoy = new Date();
      const hoyStr = hoy.toISOString().split('T')[0];
      setFechaEntregaReal(hoyStr);
      setPendingFechaEntregaReal({ iniciativa, nuevoEstado });
      setFechaEntregaRealModalOpen(true);
      return;
    }

    // Si se intenta mover a 'aprobada' (con fecha ya establecida), verificar supervisión y campos de aprobación
    if (nuevoEstado === 'aprobada') {
      try {
        const response = await iniciativasAPI.checkSupervision(iniciativa.id);
        if (!response.data.can_move_to_entregada) {
          setPendingStateChange({ iniciativa, nuevoEstado });
          setSupervisionStatus(response.data);
          setSupervisionModalOpen(true);
          return;
        }
      } catch (err) {
        console.error('Error al verificar supervisión:', err);
        setError('Error al verificar la supervisión de la iniciativa');
        setTimeout(() => setError(null), 5000);
        return;
      }
      const faltaImporte = !iniciativa.importe_total_cliente;
      const faltaFechaAprobacion = !iniciativa.fecha_de_aprobacion_propuesta_firmada;
      if (faltaImporte || faltaFechaAprobacion) {
        setPendingAprobada({ iniciativa, nuevoEstado });
        setAprobadaModalOpen(true);
        return;
      }
    }

    // Si no requiere supervisión/enlace o ya los tiene, proceder con el cambio
    try {
      // 'aprobada' es el valor de display del backend; el valor real en BD es 'aprobado'
      const estadoParaAPI = nuevoEstado === 'aprobada' ? 'aprobado' : nuevoEstado;
      await iniciativasAPI.partialUpdate(iniciativa.id, { estado: estadoParaAPI });
      setDraggedItem(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error('Error al actualizar el estado de la iniciativa:', err);
      setError(`Error al actualizar el estado: ${err.message}`);
      setTimeout(() => setError(null), 5000);
    }
  };

  // Confirmar modal de aprobada (guardar campos faltantes y cambiar estado)
  const handleAprobadaConfirm = async (data) => {
    if (!pendingAprobada) return;
    setAprobadaLoading(true);
    try {
      await iniciativasAPI.partialUpdate(pendingAprobada.iniciativa.id, {
        ...data,
        estado: 'aprobado'
      });
      setAprobadaModalOpen(false);
      setPendingAprobada(null);
      setDraggedItem(null);
      if (onRefresh) onRefresh();
    } catch (err) {
      console.error('Error al aprobar la iniciativa:', err);
      setError('Error al guardar los datos y aprobar la iniciativa');
      setTimeout(() => setError(null), 5000);
    } finally {
      setAprobadaLoading(false);
    }
  };

  const handleAprobadaClose = () => {
    setAprobadaModalOpen(false);
    setPendingAprobada(null);
    setDraggedItem(null);
  };

  // Confirmar fecha de entrega real y continuar con el flujo de supervisión
  const handleFechaEntregaRealConfirm = async (fecha) => {
    if (!pendingFechaEntregaReal) return;
    setFechaEntregaRealModalOpen(false);
    // Guardar la fecha en la iniciativa
    try {
      await iniciativasAPI.partialUpdate(pendingFechaEntregaReal.iniciativa.id, {
        fecha_de_entrega_propuesta_real: fecha
      });
    } catch (err) {
      setError('Error al guardar la fecha de entrega real');
      setTimeout(() => setError(null), 5000);
      setPendingFechaEntregaReal(null);
      return;
    }
    // Verificar supervisión
    try {
      const response = await iniciativasAPI.checkSupervision(pendingFechaEntregaReal.iniciativa.id);
      if (!response.data.can_move_to_entregada) {
        setPendingStateChange({ iniciativa: pendingFechaEntregaReal.iniciativa, nuevoEstado: pendingFechaEntregaReal.nuevoEstado });
        setSupervisionStatus(response.data);
        setSupervisionModalOpen(true);
        setPendingFechaEntregaReal(null);
        return;
      }
    } catch (err) {
      setError('Error al verificar la supervisión de la iniciativa');
      setTimeout(() => setError(null), 5000);
      setPendingFechaEntregaReal(null);
      return;
    }
    // Si se está moviendo a 'aprobada', verificar campos antes de cambiar estado
    if (pendingFechaEntregaReal.nuevoEstado === 'aprobada') {
      const init = pendingFechaEntregaReal.iniciativa;
      const faltaImporte = !init.importe_total_cliente;
      const faltaFechaAprobacion = !init.fecha_de_aprobacion_propuesta_firmada;
      if (faltaImporte || faltaFechaAprobacion) {
        setPendingAprobada({ iniciativa: init, nuevoEstado: 'aprobada' });
        setAprobadaModalOpen(true);
        setPendingFechaEntregaReal(null);
        return;
      }
    }
    // Si pasa la supervisión, cambiar estado
    try {
      const estadoParaAPI = pendingFechaEntregaReal.nuevoEstado === 'aprobada' ? 'aprobado' : pendingFechaEntregaReal.nuevoEstado;
      await iniciativasAPI.partialUpdate(pendingFechaEntregaReal.iniciativa.id, { estado: estadoParaAPI });
      setDraggedItem(null);
      setPendingFechaEntregaReal(null);
      if (onRefresh) onRefresh(); else window.location.reload();
    } catch (err) {
      setError('Error al actualizar el estado');
      setTimeout(() => setError(null), 5000);
      setPendingFechaEntregaReal(null);
    }
  };

  // Cancelar modal de fecha entrega real
  const handleFechaEntregaRealClose = () => {
    setFechaEntregaRealModalOpen(false);
    setPendingFechaEntregaReal(null);
  };

  // Confirmar motivo de rechazo
  const handleMotivoRechazoConfirm = async (motivo) => {
    if (!pendingRechazo) return;
    setMotivoRechazoModalOpen(false);
    try {
      await iniciativasAPI.partialUpdate(pendingRechazo.iniciativa.id, {
        motivo_tipificado: motivo,
        estado: pendingRechazo.nuevoEstado
      });
      setDraggedItem(null);
      setPendingRechazo(null);
      if (onRefresh) onRefresh(); else window.location.reload();
    } catch (err) {
      console.error('Error al guardar motivo de rechazo:', err);
      setError('Error al guardar el motivo de rechazo');
      setTimeout(() => setError(null), 5000);
      setPendingRechazo(null);
    }
  };

  // Cancelar modal de motivo de rechazo
  const handleMotivoRechazoClose = () => {
    setMotivoRechazoModalOpen(false);
    setPendingRechazo(null);
    setDraggedItem(null);
  };
  
  const handleSupervisionConfirm = async (supervisionData) => {
    if (!pendingStateChange) return;
    
    setSupervisionLoading(true);
    try {
      // Marcar supervisión
      await iniciativasAPI.marcarSupervision(
        pendingStateChange.iniciativa.id, 
        supervisionData
      );

      // Si se está moviendo a 'aprobada', verificar campos antes de cambiar estado
      if (pendingStateChange.nuevoEstado === 'aprobada') {
        const init = pendingStateChange.iniciativa;
        const faltaImporte = !init.importe_total_cliente;
        const faltaFechaAprobacion = !init.fecha_de_aprobacion_propuesta_firmada;
        if (faltaImporte || faltaFechaAprobacion) {
          setPendingAprobada({ iniciativa: init, nuevoEstado: 'aprobada' });
          setAprobadaModalOpen(true);
          setSupervisionModalOpen(false);
          setPendingStateChange(null);
          setSupervisionStatus(null);
          setDraggedItem(null);
          setSupervisionLoading(false);
          return;
        }
      }

      // Cambiar estado
      const estadoParaAPI = pendingStateChange.nuevoEstado === 'aprobada' ? 'aprobado' : pendingStateChange.nuevoEstado;
      await iniciativasAPI.partialUpdate(
        pendingStateChange.iniciativa.id, 
        { estado: estadoParaAPI }
      );
      
      setSupervisionModalOpen(false);
      setPendingStateChange(null);
      setSupervisionStatus(null);
      setDraggedItem(null);
      
      // Recargar datos
      if (onRefresh) onRefresh(); else window.location.reload();
    } catch (err) {
      console.error('Error al marcar supervisión y cambiar estado:', err);
      setError('Error al actualizar la supervisión y el estado');
      setTimeout(() => setError(null), 5000);
    } finally {
      setSupervisionLoading(false);
    }
  };
  
  const handleSupervisionClose = () => {
    setSupervisionModalOpen(false);
    setPendingStateChange(null);
    setSupervisionStatus(null);
    setDraggedItem(null);
  };
  
  const handleEnlaceConfirm = async (enlace) => {
    if (!pendingStateChange) return;
    
    setEnlaceLoading(true);
    try {
      // Guardar enlace
      await iniciativasAPI.guardarEnlacePropuesta(
        pendingStateChange.iniciativa.id, 
        { enlace_al_documento_ppt_sharepoint: enlace }
      );
      
      setEnlaceModalOpen(false);
      
      // Si el estado destino es "entregada", o "aprobada" sin fecha entrega real,
      // continuar por el modal de fecha entrega real (que gestiona supervisión internamente)
      if (pendingStateChange.nuevoEstado === 'entregada' ||
          (pendingStateChange.nuevoEstado === 'aprobada' && !pendingStateChange.iniciativa.fecha_de_entrega_propuesta_real)) {
        const hoy = new Date().toISOString().split('T')[0];
        setFechaEntregaReal(hoy);
        setPendingFechaEntregaReal({ ...pendingStateChange });
        setPendingStateChange(null);
        setFechaEntregaRealModalOpen(true);
        return;
      }

      // Si "aprobada" con fecha ya establecida, verificar supervisión y campos de aprobación
      if (pendingStateChange.nuevoEstado === 'aprobada') {
        const response = await iniciativasAPI.checkSupervision(pendingStateChange.iniciativa.id);
        if (!response.data.can_move_to_entregada) {
          setSupervisionStatus(response.data);
          setSupervisionModalOpen(true);
          setEnlaceLoading(false);
          return;
        }
        const init = pendingStateChange.iniciativa;
        const faltaImporte = !init.importe_total_cliente;
        const faltaFechaAprobacion = !init.fecha_de_aprobacion_propuesta_firmada;
        if (faltaImporte || faltaFechaAprobacion) {
          setPendingAprobada({ iniciativa: init, nuevoEstado: 'aprobada' });
          setAprobadaModalOpen(true);
          setPendingStateChange(null);
          setEnlaceActual('');
          setEnlaceLoading(false);
          return;
        }
        await iniciativasAPI.partialUpdate(init.id, { estado: 'aprobado' });
        setPendingStateChange(null);
        setEnlaceActual('');
        setDraggedItem(null);
        if (onRefresh) onRefresh(); else window.location.reload();
        return;
      }

      // Cambiar estado (para supervision u otros estados)
      await iniciativasAPI.partialUpdate(
        pendingStateChange.iniciativa.id, 
        { estado: pendingStateChange.nuevoEstado }
      );
      
      setPendingStateChange(null);
      setEnlaceActual('');
      setDraggedItem(null);
      if (onRefresh) onRefresh(); else window.location.reload();
    } catch (err) {
      console.error('Error al guardar enlace y cambiar estado:', err);
      setError('Error al guardar el enlace y actualizar el estado');
      setTimeout(() => setError(null), 5000);
    } finally {
      setEnlaceLoading(false);
    }
  };
  
  const handleEnlaceClose = () => {
    setEnlaceModalOpen(false);
    setPendingStateChange(null);
    setEnlaceActual('');
    setDraggedItem(null);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDragStart = (iniciativa) => {
    setDraggedItem(iniciativa);
  };

  const getIniciativasPorEstado = (estado) => {
    return iniciativas.filter(iniciativa => iniciativa.estado === estado);
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Cargando...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        {error}
      </div>
    );
  }

  // Calcular ancho total estimado de las columnas
  const calculateTotalWidth = () => {
    let totalWidth = 0;
    estadosComerciales.forEach(estado => {
      const iniciativasPorEstado = getIniciativasPorEstado(estado.key);
      const isEmpty = iniciativasPorEstado.length === 0;
      totalWidth += isEmpty ? 60 : 200; // 60px para vacías, 200px para con contenido
      totalWidth += 8; // gap entre columnas (4px * 2)
    });
    return totalWidth;
  };

  const totalEstimatedWidth = calculateTotalWidth();
  const shouldCenter = totalEstimatedWidth < (window.innerWidth - 100); // -100px para márgenes

  return (
    <div className={`kanban-comercial ${embedded ? 'embedded' : ''}`}>
      <div style={{
        width: '100%',
        height: 'calc(100vh - 200px)',
        overflowX: 'auto',
        overflowY: 'hidden',
        padding: '8px 0'
      }}>
        <div style={{
          display: 'flex',
          gap: '0px',
          minWidth: 'fit-content',
          // Centramos solo si el contenido cabe en el viewport
          justifyContent: shouldCenter ? 'center' : 'flex-start',
          margin: shouldCenter ? '0' : '0 auto',
          height: '100%',
          scrollbarHeight: '8px',
          scrollbarColor: '#d1d7dc transparent'
        }}>
        {estadosComerciales.map(estado => (
          <KanbanColumn
            key={estado.key}
            estado={estado.key}
            titulo={estado.label}
            iniciativas={getIniciativasPorEstado(estado.key)}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            draggedItem={draggedItem}
            onDragStart={handleDragStart}
            isFiltered={false}
          />
        ))}
        </div>
      </div>
      
      {/* Modal de fecha de entrega real */}
      <FechaEntregaRealModal
        open={fechaEntregaRealModalOpen}
        onClose={handleFechaEntregaRealClose}
        onConfirm={handleFechaEntregaRealConfirm}
        initialDate={fechaEntregaReal}
      />

      {/* Modal de supervisión */}
      <SupervisionModal
        open={supervisionModalOpen}
        onClose={handleSupervisionClose}
        onConfirm={handleSupervisionConfirm}
        iniciativaId={pendingStateChange?.iniciativa?.id}
        supervisionStatus={supervisionStatus}
        loading={supervisionLoading}
      />
      
      {/* Modal de enlace propuesta */}
      <EnlacePropuestaModal
        open={enlaceModalOpen}
        onClose={handleEnlaceClose}
        onConfirm={handleEnlaceConfirm}
        iniciativaId={pendingStateChange?.iniciativa?.id}
        enlaceActual={enlaceActual}
        loading={enlaceLoading}
        estadoDestino={pendingStateChange?.nuevoEstado}
      />

      {/* Modal de motivo de rechazo */}
      <MotivoRechazoModal
        open={motivoRechazoModalOpen}
        onClose={handleMotivoRechazoClose}
        onConfirm={handleMotivoRechazoConfirm}
        motivoActual={pendingRechazo?.iniciativa?.motivo_tipificado || ''}
      />

      {/* Modal de campos requeridos para aprobar */}
      <AprobadaModal
        open={aprobadaModalOpen}
        onClose={handleAprobadaClose}
        onConfirm={handleAprobadaConfirm}
        iniciativa={pendingAprobada?.iniciativa}
        loading={aprobadaLoading}
      />
    </div>
  );
};

export default KanbanComercial;